import { Zrm_RenterProfile_Attributes, Zrm_RenterProfile_PetDetails } from '../types/GraphqlTypes';

const ATTRIBUTE_TO_TITLE_MAP: Record<
  keyof Omit<Zrm_RenterProfile_Attributes, 'isSmoker' | 'updatedAtMs' | '__typename'>,
  string
> = {
  moveInDate: 'Ideal move in date',
  introduction: 'Introduction',
  numOccupants: 'Total occupants',
  numBedrooms: 'Total bedrooms desired',
  credit: 'Credit score',
  jobTitle: 'Job title',
  incomeYearly: 'Annual income', // Deprecate
  incomeYearlyRange: 'Annual income',
  voucherAmountMonthly: 'Housing voucher amount',
  isSmokerBoolean: 'Smoker',
  petDetails: 'Pets',
  desiredParking: 'Parking needed',
  reasonForMoving: 'Reason for move in',
  leaseLengthMonths: 'Desired lease duration',
};

type RenterProfileAttribute = {
  title: string;
  value: string;
};

/**
 * @description Takes in Zrm_RenterResume data and returns an array of RenterProfileAttribute for the Renter Profile column
 */
export const getFormattedAttributesList = (
  data: Zrm_RenterProfile_Attributes | null | undefined,
): Array<RenterProfileAttribute> => {
  if (!data) {
    return [];
  }

  const formattedAttributesList: Array<RenterProfileAttribute> = [];

  for (const [key, value] of Object.entries(ATTRIBUTE_TO_TITLE_MAP)) {
    const currentValue = data[key as keyof Zrm_RenterProfile_Attributes];

    if (currentValue !== null && currentValue !== undefined && currentValue !== '') {
      let valueToAdd = `${currentValue}`;
      let skipAdd = false;

      if (key === 'petDetails' && Array.isArray(currentValue)) {
        valueToAdd = value.length ? getFormattedPetDetails(currentValue) : '';

        if (!valueToAdd) {
          skipAdd = true;
        }
      } else if (key === 'isSmokerBoolean') {
        valueToAdd = currentValue ? 'Yes' : 'No';
      } else if (key === 'leaseLengthMonths') {
        valueToAdd = `${currentValue} month(s)`;
      }

      if (!skipAdd) {
        formattedAttributesList.push({
          title: value,
          value: valueToAdd,
        });
      }
    }
  }

  return formattedAttributesList;
};

/**
 * @description Formats a list of Zrm_RenterProfile_PetDetails into a string
 * Ex: Large Dog (Labrador 50 lbs), Other (fish)
 */
export const getFormattedPetDetails = (petDetails: Array<Zrm_RenterProfile_PetDetails | null>): string => {
  const allPetDetails: Array<string> = [];

  petDetails?.forEach((petDetail) => {
    const { breed, description, size, type, weightPounds } = petDetail || {};

    if (!type) {
      return '';
    }

    const prefix = size ? `${size} ${type}` : type;
    const additionalAttributes = [];

    if (breed) {
      additionalAttributes.push(breed);
    }

    if (description) {
      additionalAttributes.push(description);
    }

    if (weightPounds) {
      additionalAttributes.push(weightPounds);
    }

    const details = additionalAttributes.length ? `${prefix} (${additionalAttributes.join(' ')})` : prefix;
    allPetDetails.push(details);
  });

  return allPetDetails?.join(', ');
};
